/**
 * Ссылки на три документа с просмотром в листе — там, где уйти на отдельный
 * экран нельзя: шаг согласий A-05 и блокирующий экран SYS-05.
 */
import { useState } from 'react'

import type { LegalDocument as LegalDocumentId } from '@shared/api/types'
import { Button, Sheet } from '@shared/ui'

import { LegalDocument } from './LegalDocument'
import { LEGAL_TEXTS } from './documents'
import styles from './legal.module.css'

const ORDER: LegalDocumentId[] = ['terms', 'privacy', 'community_rules']

export function LegalLinks(): React.ReactElement {
  const [open, setOpen] = useState<LegalDocumentId | null>(null)

  return (
    <>
      <div className={styles['links']}>
        {ORDER.map((id) => (
          <Button key={id} size="sm" variant="tonal" iconStart="document" onClick={() => setOpen(id)}>
            {LEGAL_TEXTS[id].title}
          </Button>
        ))}
      </div>

      <Sheet
        open={open !== null}
        onClose={() => setOpen(null)}
        title={open ? LEGAL_TEXTS[open].title : undefined}
      >
        {open ? <LegalDocument id={open} compact /> : null}
      </Sheet>
    </>
  )
}

/**
 * Сноска согласия над кнопкой — вместо отдельного тумблера (изменение v1.11).
 *
 * Согласие даётся самим действием («Продолжить»), как в Telegram и почти везде, где
 * регистрация занимает один экран. Документы читаются здесь же, не покидая экран:
 * версии всё так же фиксируются в `POST /me/consents` (A-05).
 */
export function LegalConsentNote(): React.ReactElement {
  const [open, setOpen] = useState<LegalDocumentId | null>(null)

  const link = (id: LegalDocumentId, text: string): React.ReactElement => (
    <button type="button" className={styles['inlineLink']} onClick={() => setOpen(id)}>
      {text}
    </button>
  )

  return (
    <>
      <p className={styles['consentNote']}>
        Продолжая, вы принимаете {link('terms', 'условия использования')},{' '}
        {link('privacy', 'политику приватности')} и {link('community_rules', 'правила сообщества')}.
      </p>

      <Sheet
        open={open !== null}
        onClose={() => setOpen(null)}
        title={open ? LEGAL_TEXTS[open].title : undefined}
      >
        {open ? <LegalDocument id={open} compact /> : null}
      </Sheet>
    </>
  )
}
